module.exports = __webpack_public_path__ + "static/media/Filters_HowItWorks.76d6f616.gif";